import { scene } from '../main/scene-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { testRig_common } from './testRig_common-sidecar'
import { machines } from '../machines/machines-sidecar'
import { worldSettings } from '../models/worldSettings-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { iteratee } from 'lodash'
import { tilesShip } from '../tiles/tilesShip-sidecar'

export const createTestRig_leakO2 = (x: number, y: number) => {
  let ctx = scene.getContext()

  let w = 14
  let h = 7
  let std = tilesDataShip.getStandard()

  tileMapEditor.setMode('o2')

  worldSettings.setNeedsNull()
  // worldSettings.setNeeds({
  //   thirstRate: worldSettings.defaultNeeds.thirstRate * 10,
  // })

  testRig_common.createBasicShip(x, y)

  let t = tileMapShip.getTile(ctx.mapShip, x + 5, y)
  if (t) {
    tilesShip.setFloor(t, null)
  }

  let m = monsters.create('human', 1)
  monsters.moveToTile(m, ctx.mapShip, x + 4, y + 3)
  m.isInsideShip = true
  monsters.setInSuit(m, false)
  monsterSelector.select(m)
}
